import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const points = ['Tienes mentalidad de crecimiento y visión de futuro.', 'Eres una persona organizada y responsable.', 'Estás dispuesto/a a aprender y capacitarte.', 'Te interesa desarrollar nuevas habilidades.', 'Buscas generar una fuente adicional de ingresos.', 'Tienes iniciativa y estás dispuesto/a a trabajar por tus objetivos.'];
export function Resonates() {
  return <section id="resuena" className="w-full scroll-mt-16 bg-ink-700 py-24 sm:py-32 lg:py-40" aria-labelledby="resonates-title" data-id="element-234" data-mp="388pqc283h182">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-235" data-mp="3i5vk5i83f6bz">
        <Reveal data-id="element-236" data-mp="3d6999ffqm26c">
          <h2 id="resonates-title" className="max-w-2xl font-sans text-[1.85rem] font-light uppercase leading-[1.15] text-ivory sm:text-4xl xl:text-5xl" data-id="element-237" data-mp="3d5pwse8uw5zp">
            ¿Esto podría ser para ti?
          </h2>
          <p className="mt-5 font-serif text-2xl italic text-champagne sm:text-3xl" data-id="element-238" data-mp="shuwmxstzg2n">
            Puede serlo si...
          </p>
        </Reveal>

        <ul className="mt-14 grid grid-cols-1 gap-x-16 border-t border-ivory/12 sm:mt-16 md:grid-cols-2" data-id="element-239" data-mp="1nk02ggbgdrdh">
          {points.map((point, i) => <li key={point} className="border-b border-ivory/12" data-id="element-240" data-mp="1ske0r6n95myb" data-mpi={i}>
              <Reveal delay={Math.min(i * 0.05, 0.25)} data-id="element-241" data-mp="1xho2nlrtvr31">
                <div className="flex items-start gap-5 py-7" data-id="element-242" data-mp="zuysupqvwa6m">
                  <CheckIcon className="mt-1 h-4 w-4 flex-none text-champagne" strokeWidth={1.5} aria-hidden="true" data-id="element-243" data-mp="zwi9wikd6p9g" />
                  <p className="font-sans text-[17px] font-light leading-relaxed text-ivory/90 sm:text-lg" data-id="element-244" data-mp="19rjz1een3rc1">
                    {point}
                  </p>
                </div>
              </Reveal>
            </li>)}
        </ul>

        <Reveal data-id="element-245" data-mp="m3k7wddf1ywx">
          <div className="mt-16 max-w-3xl sm:mt-20" data-id="element-246" data-mp="m30nmq0amyfq">
            <p className="font-sans text-2xl font-light uppercase leading-tight tracking-[0.02em] text-ivory sm:text-4xl" data-id="element-247" data-mp="m1fun4tmnnjz">
              No necesitas experiencia.
            </p>
            <p className="mt-3 font-serif text-2xl italic leading-snug text-champagne sm:text-[2.1rem]" data-id="element-248" data-mp="938cu10qs2ve">
              Necesitas disposición para aprender, crecer y tomar acción.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}